export default {
  SET_BRAND_INFO: 'SET_BRAND_INFO',
  SET_LOAD_MSG: 'SET_LOAD_MSG',
  SET_ERROR_MSG: 'SET_ERROR_MSG',
  CLEAR_ERROR_MSG: 'CLEAR_ERROR_MSG',
  SET_RECEIVED_COUPONS_INFO: 'SET_RECEIVED_COUPONS_INFO',
  SET_LANGUAGE_INFO: 'SET_LANGUAGE_INFO',
};



// WEBPACK FOOTER //
// ./src/consts/common-action-type.js